import { HTTP } from '../../utils'

/* global LearnosityAuthor:true */
export const createLearnosityItem = (router, reference) => {
  const hostname = window.location.hostname
  var url = 'assessment/launchItemWizard?mode=item_edit'
  if (reference && reference.length > 0) {
    url += '&reference=' + reference
  }
  url += '&hostname=' + hostname
  HTTP().get(url)
  .then(res => {
    return res.data
  })
  .then(data => {
    var authorApp = LearnosityAuthor.init(data, {
      'readyListener': function () {
        bindEvents()
      }
    })

    function bindEvents () {
      authorApp.on('save', function (event) {
        let message = ''
        let error = false
        let questions = event.data.questions
        for (var i = 0; i < questions.length; i++) {
          let validation = questions[i].data.validation
          if (!validation) {
            error = true
            message = 'Max score is missing.'
            break
          } else {
            if (validation.automarkable === false) {
              if (!validation.max_score) {
                error = true
                message = 'Max score is missing.'
                break
              }
            } else {
              if (validation.valid_response && validation.valid_response.value.length === 0) {
                error = true
                message = 'Correct answer(s) is missing.'
                break
              }
            }
          }
        }
        if (error) {
          alert(message)
          // event.preventDefault()
        }
      }).on('save:success', function (event) {
        // console.log(event)
        router.push({name: 'listItem'})
      }).on('save:error', function (event) {
        console.log(event)
      })
    }
  })
  .catch(e => {
    console.log(e)
  })
}

export const listLearnosityItem = (router) => {
  const hostname = window.location.hostname
  HTTP().get('assessment/launchItemWizard?mode=item_list&hostname=' + hostname)
  .then(res => {
    return res.data
  })
  .then(data => {
    var authorApp = LearnosityAuthor.init(data, {
      'readyListener': function () {
        bindEvents()
      }
    })

    function bindEvents () {
      var reference
      authorApp.on('open:item', function (event) {
        reference = event.data.item.reference
      }).on('render:item', function (event) {
        // console.log(event)
        router.push('/item/' + reference)
      })
    }
  })
  .catch(e => {
    console.log(e)
  })
}

export const createLearnosityAssessment = () => {
  const hostname = window.location.hostname
  return HTTP().put('assessment/create?hostname=' + hostname)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveActivitySuccess = (data) => {
  const url = 'assessment/saveActivitySuccess/' + data.uuid
  return HTTP().put(url, data).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const generateSignedRequestForActivity = (uuid) => {
  const hostname = window.location.hostname
  return HTTP().get('assessment/' + uuid + '/edit/generateSignedRequest?hostname=' + hostname)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAssessmentDetail = (uuid) => {
  return HTTP().get('assessment/info/' + uuid).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAssessmentDetail2 = (uuid, userId) => {
  let url = 'assessment/info2/' + uuid
  if (userId) {
    url += '?userId=' + userId
  }
  return HTTP().get(url).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getUngradedAttempts = (assessments) => {
  return HTTP().put('attempt/ungradedAttemtps', assessments).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const startAssessment = (uuid, courseId, sessionId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchAssessmentWizard/' + uuid + '?courseId=' + courseId
  if (sessionId) {
    url += '&sessionId=' + sessionId
  }
  url += '&hostname=' + hostname
  return HTTP().get(url).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateLaunchedAttempt = (sessionId, externalId, isFinished) => {
  const hostname = window.location.hostname
  return HTTP().put('attempt/attemptFinished/' + sessionId + '?externalId=' + externalId + '&isFinished=' + isFinished + '&hostname=' + hostname)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateAttemptReport = (activityId, sessionId, courseId, userId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchReportWizard/' + activityId + '?sessionId=' + sessionId + '&courseId=' + courseId + '&hostname=' + hostname
  if (userId) {
    url += '&userId=' + userId
  }
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const populateAttemptAIReport = (activityId, sessionId, courseId, userId) => {
  const hostname = window.location.hostname
  var url = 'attempt/summary/' + activityId + '?sessionId=' + sessionId + '&courseId=' + courseId + '&hostname=' + hostname
  if (userId) {
    url += '&userId=' + userId
  }
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const populateAttemptReportForUser = (userId, sessionId, courseId, widgetId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchReportWizardForUser/' + userId + '?sessionId=' + sessionId
  if (courseId) {
    url += '&courseId=' + courseId
  }
  if (widgetId) {
    url += '&widgetId=' + widgetId
  }
  url += '&hostname=' + hostname
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateAttemptManualGradingReportForUser = (activityId, userId, sessionId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchManualGradingReportWizard/' + activityId + '/' + userId + '?sessionId=' + sessionId + '&hostname=' + hostname
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAssessmentAttemptForClass = (assessmentId, users) => {
  return HTTP().put('attempt/launchClassReportWizard/' + assessmentId, users)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getFieldsForClassReport = (assessmentId) => {
  return HTTP().get('attempt/getFieldsForClassReport/' + assessmentId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const startManualGradingForUser = (data) => {
  const hostname = window.location.hostname
  return HTTP().put('attempt/launchManualGradingWizard?hostname=' + hostname, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateAttemptManualGrade = (data) => {
  const hostname = window.location.hostname
  return HTTP().put('attempt/updateAttemptManualGrade?hostname=' + hostname, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateManuallyGradedReportWizardForUser = (data) => {
  const hostname = window.location.hostname
  return HTTP().put('attempt/launchManuallyGradedReportWizard?hostname=' + hostname, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getLibrariesForUser = (userId) => {
  return HTTP().get('learningspace/user?userUuid=' + userId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getAllLibrariesForUser = () => {
  return HTTP().get('learningspace/user/includeshared')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getRichHtmlAssessment = (ancestor) => {
  return HTTP().get('assessment/childRichHtml/' + ancestor).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const startRichHtmlAssessment = (uuid, sessionId, courseId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchRichHtmlAssessmentWizard/' + uuid + '?sessionId=' + sessionId
  if (courseId) {
    url += '&courseId=' + courseId
  }
  url += '&hostname=' + hostname
  return HTTP().get(url).then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const populateRichHtmlAssessmentReport = (activityId, sessionId) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchRichHtmlAssessmentReport/' + activityId + '?sessionId=' + sessionId + '&hostname=' + hostname
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getFieldsForQuestionLevelClassReport = (assessmentId, attemptNumber, users) => {
  return HTTP().get('attempt/getFieldsForQuestionLevelClassReport/' + assessmentId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getDiagnosticTestReport = (courseId, assessmentId) => {
  return HTTP().get('competency/diagnosticreport/' + courseId + '/' + assessmentId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getDiagnosticTestReportForIns = (userId, courseId, assessmentId) => {
  return HTTP().get('competency/user/'+userId+'/diagnosticreport/' + courseId + '/' + assessmentId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getAttemptSummaryForClass = (assessmentId, attemptNumber, users) => {
  var url = 'attempt/attemptSummary/' + assessmentId + '?attemptNumber=' + attemptNumber
  return HTTP().put(url, users)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const launchLocalPracticeReview = (uuid, courseId, sessionId, responses) => {
  const hostname = window.location.hostname
  var url = 'attempt/launchLocalPracticeReviewWizard/' + uuid + '/' + sessionId + '?courseId=' + courseId + '&hostname=' + hostname
  return HTTP().put(url, responses).then(resp => {
    return resp.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveUserCareerCriteriaList = (userCareerCriteriaList) => {
  return HTTP().put('user/clearlynext/updateUserCareerCriteriaList/', userCareerCriteriaList)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveUserTopSkillList = (userTopSkillList) => {
  return HTTP().put('user/clearlynext/updateUserTopSkillList/', userTopSkillList)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveUserMostEnergizeWorkList = (userMostEnergizeWorkList) => {
  return HTTP().put('user/clearlynext/updateUserMostEnergizeWorkList/', userMostEnergizeWorkList)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveUserConversationQuestionMap = (userConversationQuestionMap) => {
  return HTTP().put('user/clearlynext/updateUserConversationQuestionMap/', userConversationQuestionMap)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveUserMostInterestingIdeaList = (userMostInterestingIdeaList) => {
  return HTTP().put('user/clearlynext/updateUserMostInterestingIdeaList/', userMostInterestingIdeaList)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const postUploadDiagnosticLogicMappingCsvFile = (fileData) => {
  if (!fileData) {
    return
  }
  let url = '/assessment/diagnosticLogicMapping/upload'
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/assessment/api.js